module.exports = __webpack_public_path__ + "static/media/camera-icon.9859f35e.png";